<template>
    <div class="cancel-favorite">
        <h3><v-icon>mdi-help-circle-outline</v-icon>{{ $TL.unfavorite }}</h3>
        <p>{{ $TL.sureToUnfavorite }}</p>
        <div class="operate-btm d-flex justify-content-end">
            <v-btn class="cancel-btn def" @click="cancel">{{
                $TL.cancel
            }}</v-btn>
            <v-btn class="agree-btn def gradient-bg" @click="cancel_favorite">{{
                $TL.agree
            }}</v-btn>
        </div>
    </div>
</template>

<script>
import { cancelPictureFavorite } from "@/api/interface.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "cancel-favorite",
    data() {
        return {};
    },
    computed: {
        ...mapState("favorites", ["pictureId", "pictureIndex"])
    },
    methods: {
        ...mapMutations("vModal", ["updateOpenPictuerModal"]),
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),
        ...mapMutations("favorites", ["updateFavoritesStatus"]),
        cancel() {
            this.$P.$emit("closeModal");
        },
        async cancel_favorite() {
            try {
                let { data } = await cancelPictureFavorite({
                    media_ids: this.pictureId
                });
                this.updateFavoritesStatus({
                    itemIndex: this.pictureIndex,
                    isFavor: 1
                });
                this.$P.$emit("closeModal");
                this.updateSnackbar(this.$TL.UnfavoriteSuccessful);
                this.close_picture_view();
            } catch (e) {
                if (e?.response?.status === 500) {
                    this.updateSnackbar(this.$TL.UnfavouriteFailed);
                }
            }
        },

        //  判断是个人收藏中心，则关闭图片详情弹框
        close_picture_view() {
            if (
                this.$route.name === "favorites" ||
                this.$route.name === "favorites-details"
            ) {
                this.updateOpenPictuerModal(false);
            }
        }
    }
};
</script>

<style lang="scss">
.cancelFavorite,
.removeFavorite {
    .v-dialog {
        width: 344px;
    }
}

.remove-favorite,
.cancel-favorite {
    padding: 12px;

    h3 {
        @include flex(center);

        i {
            color: #faad14 !important;
            margin-right: 4px;
        }
    }

    p {
        margin: {
            top: 16px;
            bottom: 0;
        }
        padding-left: 16px;
        color: #595959;
        font-size: 14px;
    }

    .operate-btm {
        margin-top: 30px;

        .cancel-btn {
            margin-right: 10px;
        }
    }
}
</style>
